import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../components/Converter";
import KiloNewtonDividedByMillimetreSquared from "../../../../../components/Math/Units/Metric/KiloNewtonDividedByMillimetreSquared";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";

function EModul({ e_modul }) {
  const { t } = useTranslation("translation");
  const E_Formula = `\\displaystyle E = \\frac{EA_{s}}{A_{s}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.modulusOfElasticity")}</p>}
      indicesValue={<span>E</span>}
      formulaValue={<ToolTip id={"E_Formula"} type={IconType.FORMULA} formula={E_Formula} />}
      inputValue={<span className="input">{ConvertToString(e_modul, 0)}</span>}
      unitValue={<KiloNewtonDividedByMillimetreSquared />}
    />
  );
}

export default EModul;
